import React, { forwardRef, useEffect, useState } from 'react';

import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFiltersTranslation } from '../../i18n';
import { useEventListFilters } from '../../useEventListFilters';

const validateTrackIds = validate.multipleTrackIds();

const getIds = (value: string): string[] | undefined => {
  const ids = value
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

  if (ids.length === 0) return undefined;
  return ids;
};

function TrackIdFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useEventListFiltersTranslation();
  const [trackIds, setTrackIds] = useState('');
  const [error, setError] = useState('');
  const { filters, updateFilters, updateFiltersDebounced } = useEventListFilters();

  const handleChange = (value: string) => {
    setTrackIds(value);

    const validationResult = validateTrackIds(value);
    if (typeof validationResult === 'string') {
      setError(validationResult);
      return;
    }

    setError('');
    updateFiltersDebounced({ track_ids: getIds(value) });
  };

  const reset = () => {
    setTrackIds('');
    setError('');
    updateFilters({ track_ids: undefined });
  };

  useEffect(() => {
    setTrackIds(filters.track_ids?.join(',') ?? '');
  }, [filters.track_ids]);

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={filters.track_ids === undefined}
      onClickReset={reset}
      ref={ref}
      title={<div className="Subtitle-2">{t('track_ids')}</div>}
    >
      <Control.Input
        errorMessage={error}
        hasError={!!error}
        id="track_ids"
        isClearable
        name="track_ids"
        onChangeValue={handleChange}
        onClear={reset}
        value={trackIds}
      />
    </PopoverWithButton>
  );
}

const TrackIdFilterPopoverWithRef = forwardRef(TrackIdFilterPopover);
export { TrackIdFilterPopoverWithRef as TrackIdFilterPopover };
